var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("fragment", [
    _c(
      "dt",
      {
        key: _vm.question.ordered + "_title",
        staticClass: "e-question-title",
        attrs: { id: "_form_field_question" + _vm.question.ordered }
      },
      [
        _vm._v(
          "\n        " +
            _vm._s(_vm.question.ordered) +
            ".\n        " +
            _vm._s(_vm.question.label) +
            "\n    "
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "dd",
      { key: _vm.question.ordered + "_data", staticClass: "e-question-data" },
      [
        _c("div", { staticClass: "e-form-row m-block m-no-margin" }, [
          _c("div", { staticClass: "e-input-field" }, [
            _c(
              "div",
              { staticClass: "e-field-grid" },
              [
                _vm.question.answer
                  ? _vm._l(_vm.question.answer, function(answer) {
                      return _c("question-answer", {
                        key: answer.ordered,
                        attrs: { question: _vm.question, answer: answer }
                      })
                    })
                  : _vm._e()
              ],
              2
            ),
            _vm._v(" "),
            _vm.question.ordered in _vm.errorStore.question.value &&
            _vm.errorStore.question.value[_vm.question.ordered] &&
            _vm.validatedStore.question[_vm.question.ordered] !== 1
              ? _c("div", { staticClass: "c-error-alert" }, [
                  _c(
                    "div",
                    { staticClass: "e-inner" },
                    _vm._l(
                      _vm.errorStore.question.value[_vm.question.ordered],
                      function(error, index) {
                        return _c(
                          "small",
                          { key: index, staticClass: "e-input-note m-invalid" },
                          [_vm._v(_vm._s(error))]
                        )
                      }
                    ),
                    0
                  )
                ])
              : _vm._e()
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }